<!--新建工单-->
<template>
	<div class="orderBody">
		<div class="leftPart">
			<p>分组</p>
			<p class="pickerText" @click="pickerOrderGroup">{{nowOrderGroupName}}</p>
			<p>开始时间</p>
			<datePicker ref="bgTimePicker" dateType="dateTime" :initDate="orderStartTime" @checkDate="orderStartTime = $event"></datePicker>
			<p>截止时间</p>
			<datePicker ref="endTimePicker" dateType="dateTime" :initDate="orderEndTime" @checkDate="orderEndTime = $event"></datePicker>
			<p>抄送人</p>
			<p class="pickerText" @click="addUsers" :title="nowParticipantsNames">{{nowParticipantsNames}}</p>
			<p>发布方式</p>
			<div class="flexBetween cycleType">
				<p :class="{isCheck:!isCycle}" @click="isCycle = false">手动</p>
				<p :class="{isCheck:isCycle}" @click="isCycle = true">自动</p>
			</div>
			<p v-show="isCycle">周期类型</p>
			<div v-show="isCycle">
				<div class="flexBetween cycleTime">
					<p :class="{isCheck:cycleTime == 'day'}" @click="cycleTime = 'day'">日</p>
					<p :class="{isCheck:cycleTime == 'week'}" @click="cycleTime = 'week'">周</p>
					<p :class="{isCheck:cycleTime == 'month'}" @click="cycleTime = 'month'">月</p>
					<p :class="{isCheck:cycleTime == 'year'}" @click="cycleTime = 'year'">年</p>
				</div>
			</div>
			<p v-show="isCycle">预期发布时间</p>
			<p v-show="isCycle" v-for="item in cycleTimeList" style="padding: 2px 0 !important;margin: 0;">{{item}}</p>
		</div>
		<div class="rightPart custom-scrollbar" style="overflow-x: hidden;">
			<input type="text" v-model="orderTitle" placeholder="工单名称(必填)" style="width: 96%;margin: 20px 0 10px 10px;">
			<textarea cols="30" rows="5" v-model="orderContent" placeholder="工单描述(选填)" style="width: 96%;margin: 0 0 10px 10px;resize: none;"></textarea>
			<createNode ref="createNodeBean" :nowFlow="nowFlow" :orderStartTime='orderStartTime' :orderEndTime="orderEndTime"></createNode>
			<div class="flexBetween" style="flex-direction: column;float: right;">
				<p class="buttonP" @click="pickerWorkFlow" style="margin: 10px;width: 160px;">从工作流导入</p>
				<p @click="isCycle?upload('CycleOrder',cycleTime):upload('Order')" class="buttonP" style="margin: 10px;width: 160px;">发布</p>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import datePicker from '@/components/module/datePicker/base/datePicker.vue'
	import createNode from '@/page/order/createOrder/createNode.vue'
	import treeSingleSelection from '@/components/module/selection/base/treeSingleSelection.vue'
	export default {
		components: {
			treeBody,
			datePicker,
			createNode,
			treeSingleSelection,
		},
		props: [],
		data() {
			return {
				nowOrderGroup: undefined,
				showSaveToDemo: false,
				nowInputFlow: undefined,
				nowInputDemo: undefined,
				participants: [],
				orderTitle: "",
				orderContent: "",
				orderStartTime: new Date(new Date().getTime()),
				orderEndTime: new Date(new Date().getTime() + 24 * 60 * 60 * 1000 + 30 * 60 * 1000),
				nowFlow: {
					name: '默认工作流',
					next: []
				},
				isCycle: false,
				cycleTime: 'day',
				groupId:"",
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			if(this.orderGroupList != undefined) {
				this.nowOrderGroup = this.orderGroupList[0]
			}
			//从缓存中判断是否是从事件界面跳转过来的
			this.isFromEvent()
		},
		computed: {
			orderGroupList() {
				return this.$store.orderGroupStore.getters.getOrderGroupTree
			},
			priorityList() {
				return this.$store.orderStore.state.priorityList
			},
			cycleTypeList() {
				return this.$store.orderStore.state.cycleTypeList
			},
			userTree() {
				return this.$store.userStore.getters.getUnitUserTree
			},
			deleteIco() {
				return this.$store.resourcesStore.getters.getResourcesByName('/wedoButton/delete.png')
			},
			getFlowList() {
				return this.$store.workFlowStore.getters.getFlowList
			},
			getDemoList() {
				//模板列表
				return this.$store.orderStore.getters.getOrderTemplateList('NotStarted')
			},
			nowFlowTree() {
				if(this.nowInputFlow == undefined) {
					return undefined
				}
				return this.$store.workFlowStore.getters.getFlowTreeByFlowId(this.nowInputFlow.flowId)
			},
			nowParticipantsNames() {
				if(isempty(this.participants)) {
					return '点击选择抄送人'
				}
				return this.participants.map(item => item.username).join(' , ')
			},
			nowOrderGroupName() {
				if(this.nowOrderGroup == undefined) {
					return '选择分组'
				}
				return this.nowOrderGroup.name
			},
			flowTree() {
				return [{
					name: '私有工作流',
					id: '1',
					next: this.getFlowList(1)
				}, {
					name: '公有工作流',
					id: '0',
					next: this.getFlowList(0)
				}]
			},
			cycleTimeList() {
				//计算出的下两次运行时间
				var start = new Date(this.orderStartTime.getTime())
				var list = []
				list.push(start.formatByTime('-'))
				for(var i = 0; i < 3; i++) {
					switch(this.cycleTime) {
						case 'day':
							start = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1, start.getHours(), start.getMinutes(),
								start.getSeconds())
							break
						case 'week':
							start = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 7, start.getHours(), start.getMinutes(),
								start.getSeconds())
							break
						case 'month':
							var lastDate = start.getDate()
							var nDate = new Date(start.getFullYear(), start.getMonth() + 1, start.getDate(), start.getHours(), start.getMinutes(),
								start.getSeconds())
							if(lastDate != nDate.getDate()) {
								start = new Date(start.getFullYear(), start.getMonth() + 2, start.getDate(), start.getHours(), start.getMinutes(),
									start.getSeconds())
								list.push(start.formatByTime('-'))
								continue
							}
							start = nDate
							break
						case 'year':
							start = new Date(start.getFullYear() + 1, start.getMonth(), start.getDate(), start.getHours(), start.getMinutes(),
								start.getSeconds())
							break
					}
					list.push(start.formatByTime('-'))
				}
				list.push("...")
				return list
			}
		},
		watch: {
			nowFlowTree(nv, ov) {
				//加载在watch只是为了让它更快计算
			},
			userTree(nv, ov) {

			},
			orderGroupList(nv, ov) {
				this.nowOrderGroup = nv[0]
			},
			flowTree(nv, ov) {}
		},
		methods: {
			addUsers() {
				this.$dialogMethod.openMultipleSelectionDialog('抄送人', this.userTree, this.participants.map(item => item.userId),
					respon => {
						//一次可以添加多个
						this.participants = respon

					})
			},
			upload(orderType, cycleType) {
				if(isempty(this.orderTitle)) {
					this.$dialogMethod.showMessage("工单标题不能为空!")
					return
				}
				var nodes = this.$refs.createNodeBean.getData()
					// archivesIdsFun
				var archivesIdsId = this.$refs.createNodeBean.archivesIdsFun()
				console.log("发布nodes",nodes);
				console.log("发布archivesIdsId",archivesIdsId);

				let archivesIds = []

				if(nodes.length == 0) {
					this.$dialogMethod.showMessage("至少需要具有一个节点!")
					return
				}
				//var actionList = this.$refs.createNodeBean.actionList
				for(var i = 0, len = nodes.length; i < len; i++) {
					
					if(nodes[i].nodeType == 2) {
						archivesIds = nodes[i].next.map(item => {
							return item.linkObject
						}).join(",")
						nodes[i].archivesIds = copy(archivesIds)
					}
					nodes[i].archivesIds = archivesIdsId
					if(isempty(nodes[i].nodeUsers)) {
						this.$dialogMethod.showMessage("每个节点都必须有负责人!")
						return
					}
					if(isempty(nodes[i].next) && isempty(nodes[i].archivesIds) && nodes[i].nodeType == 2) {
						this.$dialogMethod.showMessage("节点类型为“巡检”时必须选择台账设备!")
						return
					}
					/* if(isempty(actionList) && nodes[i].nodeType == 0) {
						this.$dialogMethod.showMessage("操作项至少需要有一个操作步骤!")
						return
					} */
					for(var i1 = 0, len1 = nodes[i].next.length; i1 < len1; i1++) {
						var item = nodes[i].next[i1]
						if(isempty(item.next) && nodes[i].nodeType == 0) {
							this.$dialogMethod.showMessage("操作项至少需要有一个操作步骤!")
							return
						}
					}
				}

				var workTime = this.orderEndTime.getTime() - this.orderStartTime.getTime()
				// var workTime = this.orderEndTime.getTime()
				if(workTime <= 0) {
					this.$dialogMethod.showMessage("截至时间不能早于开始时间!")
					return
				} else if(this.orderEndTime.getTime() < new Date().getTime() + 30 * 60 * 1000) {
					this.$dialogMethod.showMessage("截至时间必须在30分钟后!")
					return
				}
				// console.log("请求接口");
				// return
				this.$dialogMethod.showLoading('正在发布');
				this.$api.orderApi.addOrder(this.nowOrderGroup.groupId, orderType, this.orderTitle,
					this.orderContent, this.orderStartTime.getTime(), workTime,
					undefined, cycleType,
					nodes,
					//participants
					this.participants.filter(item => {
						return item != undefined
					}).map(item => item.userId).join(',')
					,respon => {
						this.$dialogMethod.showMessage('发布成功!')
						this.$dialogMethod.closeLoading()
					})
			},
			pickerOrderGroup() {
				this.$dialogMethod.openSingleItemDialog('选择工单分组', this.orderGroupList, this.nowOrderGroup == undefined ?
					undefined : [this.nowOrderGroup.id],
					respon => {

						this.nowOrderGroup = respon[0]
					})
			},
			pickerWorkFlow() {
				this.$dialogMethod.openSingleItemDialog('选择工作流', this.flowTree, this.nowInputFlow == undefined ?
					undefined : this.nowInputFlow.id,
					respon => {
						this.nowInputFlow = respon[0]
						if(this.nowInputFlow == undefined) {
							this.$dialogMethod.showMessage('未选中工作流!')
							return
						}
						//获取工作流并且加载和提示
						this.$dialogMethod.openAgreeDialog('导入工作流', '将会覆盖当前工作流，是否继续?', respon => {
							if(this.nowFlowTree == undefined) {
								this.$dialogMethod.showMessage('当前选中工作流信息还在获取中，请稍后重试！')
							} else {
								//加载
								this.$set(this.nowFlow, 'next', copy(this.nowFlowTree.next))
							}
						})
					})
			},
			isFromEvent(){
				if (this.$store.cacheStore.state.eventToOrderCache != undefined) {
					var eventBean = this.$store.cacheStore.state.eventToOrderCache
					this.$store.cacheStore.state.eventToOrderCache = undefined
					//类型指定为抢修
					if(this.orderGroupList != undefined) {
						this.nowOrderGroup = this.orderGroupList.find(item=>item.id == 3)
					}
					//描述里面写事件内容
					this.orderContent = '告警对象:【{0}】,事件等级:【{1}】,内容:【{2}】,产生时间:【{3}】'.format(eventBean.linkobject,eventBean.levelName,eventBean.description,new Date(eventBean.time).formatByTime())
				}
			}
		}
	}
</script>

<style scoped>
	.orderBody {
		display: flex;
		justify-content: space-between;
		color: black;
		background: white;
	}
	
	.leftPart {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-direction: column;
		border: silver 1px solid;
		margin: 10px;
		border-radius: 5px;
	}
	
	.leftPart>p,
	.rightPart>p {
		width: 150px;
		margin: .1rem 0;
	}
	
	.buttonP {
		cursor: pointer;
		background: #DA7800;
		color: white;
		padding: .1rem;
		border: white .01rem solid;
		text-align: center;
		border-radius: 10px;
		margin-top: 10px;
	}
	
	.buttonP:hover,
	.saveToDemo:hover,
	.saveToDemo>p:hover {
		background: #Ca7800;
	}
	
	.uploadDiv {
		width: 160px;
		margin-top: .1rem;
	}
	
	.uploadDiv>p {
		margin: 0;
		width: 120px;
		border-radius: 10px 0 0 10px;
	}
	
	.saveToDemo {
		width: 40px;
		height: 100%;
		background: #DA7800;
		border-radius: 0 10px 10px 0;
		border: white .01rem solid;
		border-left: 0;
		cursor: pointer;
		position: relative;
	}
	
	.saveToDemo>p {
		position: absolute;
		background: #DA7800;
		width: 100px;
		left: -85px;
		padding: .1rem;
		border-radius: 10px;
		border: white .01rem solid;
		color: white;
	}
	
	.rightPart {
		width: calc(100% - 200px);
		border: silver 1px solid;
		margin: 10px;
		border-radius: 5px;
	}
	
	.participants {
		width: 130px !important;
	}
	
	.tabP {
		width: 50%;
		text-align: center;
		border-bottom: #000000 dashed 1px;
		padding: 5px 0 10px 0;
		cursor: pointer;
	}
	
	.tabP:first-child,
	.inputButtonP:first-child {
		border-right: #000000 dashed 1px;
	}
	
	.tabP:first-child {
		border-radius: 20px 0 0 0;
	}
	
	.tabP:last-child {
		border-radius: 0 20px 0 0;
	}
	
	.tabP.isCheck {
		background: #DA7800;
		color: white;
	}
	
	.inputButtonP {
		width: 50%;
		text-align: center;
		border-top: #000000 dashed 1px;
		padding: 10px 0 5px 0;
		cursor: pointer;
	}
	
	.inputButtonP:hover {
		color: #DA7800;
	}
	
	.leftPart>p.pickerText {
		margin-top: 0;
	}
	
	.pickerBody {
		width: 160px;
	}
	
	.cycleType,
	.cycleTime {
		border: silver 1px solid;
		width: 160px;
		border-radius: 5px;
	}
	
	.cycleType>p {
		text-align: center;
		width: calc((100% - 1px)/2);
		padding: 5px;
		cursor: pointer;
	}
	
	.cycleType>p:first-child {
		border-right: silver dashed 1px;
	}
	
	.cycleType>p:hover,
	.cycleType>p.isCheck,
	.cycleTime>p:hover,
	.cycleTime>p.isCheck {
		background: skyblue;
		color: white;
	}
	
	.cycleTime>p {
		width: calc((100% - 3px)/4);
		text-align: center;
		border-right: silver 1px dashed;
		cursor: pointer;
		padding: 5px 0;
	}
	
	.cycleTime>p:last-child {
		border: 0;
	}
</style>